import { FileTextIcon } from '@phosphor-icons/react'

import ReveniIcon from '../ReveniIcon.svg?react'
import { getFormattedCarrierName } from './helpers'
import * as Styles from './styles'

export const getCarrierLabel = ({ carrier, showIcon, showLogo }) => {
  const shouldRenderPlain = !showIcon && !showLogo

  return shouldRenderPlain ? (
    getFormattedCarrierName(carrier)
  ) : (
    <CarrierOption carrier={carrier} showIcon={showIcon} showLogo={showLogo} />
  )
}

const CarrierOption = ({ carrier, showIcon, showLogo }) => {
  const carrierName = getFormattedCarrierName(carrier)
  const shouldRenderPlain = !showIcon && !showLogo

  if (shouldRenderPlain) return carrierName

  return (
    <Styles.Container>
      {showIcon && (
        <Styles.TypeContainer>
          {carrier?.is_reveni_contract ? <ReveniIcon width={16} /> : <FileTextIcon size={16} />}
        </Styles.TypeContainer>
      )}

      {showLogo && carrier?.logo_url && <img src={carrier.logo_url} alt={carrier.name} />}

      {carrierName}
    </Styles.Container>
  )
}

export default CarrierOption
